// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basket-selector__toggle:focus{box-shadow:none}.basket-selector_scroll .dropdown-menu{max-height:135px;overflow-y:scroll}.basket-selector .dropdown-menu{padding:0;border-radius:8px}.basket-selector .dropdown-menu .dropdown-item:hover{border-radius:8px;background-color:rgba(221,202,109,.15)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
